import script from "./LayoutPool.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayoutPool.vue?vue&type=script&lang=ts&setup=true"

import "./LayoutPool.vue?vue&type=style&index=0&id=cc6b7dca&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc6b7dca"]])

export default __exports__